import { Injectable, inject } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { DevicesPayload } from '../../devices/components/devices.models';
import { TimezoneService } from '../../../../services/utility/timezone.service';
import { MissingProgrammingRecordsApiService } from './api/missing-programming-records-api.service';
import {
  MissingProgrammingRecordsListItemResponse,
  MissingProgrammingRecordsListResponse
} from './api/missing-programming-records-api.types';
import { MissingProgrammingRecordsList, MissingProgrammingRecordsListItem } from './missing-programming-records.types';

@Injectable({ providedIn: 'root' })
export class MissingProgrammingRecordsService {
  private readonly apiService = inject(MissingProgrammingRecordsApiService);
  private readonly timezoneService = inject(TimezoneService);

  readList(tableState: DevicesPayload): Observable<MissingProgrammingRecordsList> {
    const initState: MissingProgrammingRecordsList = { data: [], total: 0 };

    return this.apiService.readList(tableState).pipe(
      map(({ items, totalCount: total }: MissingProgrammingRecordsListResponse): MissingProgrammingRecordsList => {
        const data = items.map(
          ({
            commDeviceId,
            initialDateTimeUTC,
            lastDateTimeUTC
          }: MissingProgrammingRecordsListItemResponse): MissingProgrammingRecordsListItem => ({
            commDeviceId,
            initialTransmissionTime: this.timezoneService.formatLong(initialDateTimeUTC),
            lastTransmissionTime: this.timezoneService.formatLong(lastDateTimeUTC)
          })
        );
        return { data, total };
      }),
      catchError((): Observable<MissingProgrammingRecordsList> => of(initState))
    );
  }
}
